
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 144 15","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.887 1.935c11.685 0 11.685 11.13 23.37 11.13s11.686-11.13 23.371-11.13c11.685 0 11.685 11.13 23.37 11.13s11.689-11.13 23.37-11.13c11.681 0 11.688 11.13 23.373 11.13s11.686-11.13 23.372-11.13","stroke":"#414142","stroke-width":"3","fill":"none","stroke-linecap":"round"}})])
          )
        }
      }
    